<script setup lang="ts">
const props = defineProps<{
	disabled?: boolean;
	outlined?: boolean;
	onClick?: (_: MouseEvent) => void;
}>();
</script>

<template>
	<button
		type="button"
		:class="{
			tile: true,
			'tile-outlined': props.outlined,
			'tile-clickable': !!props.onClick && !props.disabled,
			'tile-disabled': props.disabled,
		}"
		:disabled="!props.onClick || props.disabled"
		@click="props.onClick"
	>
		<slot />
	</button>
</template>
